/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeBlocks.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Block Type Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Sunday, September 30, 2018 - 10:36:00 PM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      09/30/2018  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const BLOCK_LIST_CONTAINER_LOADED = 'BLOCK_LIST_CONTAINER_LOADED';
export const BLOCK_LIST_CONTAINER_UNLOADED = 'BLOCK_LIST_CONTAINER_UNLOADED';
export const BLOCK_LIST_TABLE_LOADED = 'BLOCK_LIST_TABLE_LOADED';
export const BLOCK_LIST_TABLE_UNLOADED = 'BLOCK_LIST_TABLE_UNLOADED';

export const BLOCK_LIST_CHANGE_GROUP = 'BLOCK_LIST_CHANGE_GROUP';
export const BLOCK_SELECT_ROW = 'BLOCK_SELECT_ROW';

export const BLOCK_ADD = 'BLOCK_ADD';
export const BLOCK_EDIT = 'BLOCK_EDIT';
export const BLOCK_DELETE = 'BLOCK_DELETE';
export const BLOCK_OPEN_WARNING = 'BLOCK_OPEN_WARNING';
export const BLOCK_CLOSE_WARNING = 'BLOCK_CLOSE_WARNING';
export const BLOCK_DELETE_DISABLE = 'BLOCK_DELETE_DISABLE';
export const BLOCK_VIEW_CHILD_ITEMS = 'BLOCK_VIEW_CHILD_ITEMS';

export const BLOCK_EDIT_CONTAINER_LOADED = 'BLOCK_EDIT_CONTAINER_LOADED';
export const BLOCK_EDIT_CONTAINER_UNLOADED = 'BLOCK_EDIT_CONTAINER_UNLOADED';
export const BLOCK_EDIT_FORM_LOADED = 'BLOCK_EDIT_FORM_LOADED';
export const BLOCK_EDIT_FORM_UNLOADED = 'BLOCK_EDIT_FORM_UNLOADED';

export const BLOCK_EDIT_DATA_LOAD = 'BLOCK_EDIT_DATA_LOAD';

export const BLOCK_EDIT_CONTAINER_SUBMIT = 'BLOCK_EDIT_CONTAINER_SUBMIT';
export const BLOCK_EDIT_CONTAINER_CANCEL = 'BLOCK_EDIT_CONTAINER_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeBlocks.js